
import { HubConnectionBuilder } from '@microsoft/signalr';
import { setActiveUsers, setConnection, ticketConnect, ticketDisconnect } from '../reducers/TicketViewSlice';
import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '../store';

const ticketViewMiddleware: Middleware = ({ getState, dispatch }) => {

    return next => action => {

        ///User connects to a ticket
        if (ticketConnect.match(action)) {
            var token = (getState() as RootState).auth?.user?.access_token;
            const { ticketId, user, tenantId } = action.payload;

            console.warn('Starting connection to SignalR TICKET hub...', user?.UId, process.env.REACT_APP_TICKET_HUB_URL);

            const connection = new HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_TICKET_HUB_URL, { accessTokenFactory: () => token })
                .withAutomaticReconnect()
                .build();

            connection.start()
                .then(() => {
                    console.warn('Connected to SignalR hub');
                    connection.send('RegisterUser', { tenantId: tenantId, ticketId: ticketId, user: user });
                    console.warn('Connected to SignalR hub');
                })
                .catch(err => console.warn('Error connecting to SignalR hub:', err));

            //Re-register the user if the connection is lost and reconnected
            connection.onreconnected(() => {
                console.warn('REConnected to SignalR hub');

                connection.send('RegisterUser', { tenantId: tenantId, ticketId: ticketId, user: user });
            })

            connection.on('UpdateActiveUsers', (ticketId, users) => {
                console.info('UpdateActiveUsers', users, ticketId);
                dispatch(setActiveUsers({ ticketId, users }));
            });

            //Saves the connection
            dispatch(setConnection(connection));
        }

        ///User connects to a ticket
        if (ticketDisconnect.match(action)) {
            const connection = (getState() as RootState).ticketViewSlice.connection;
            const { ticketId, user, tenantId } = action.payload;

            connection.send('UnRegisterUser', { tenantId: tenantId, ticketId: ticketId, user: user })
                .then(() => connection.stop())
                .catch(err => console.log('Error disconnecting from SignalR hub:', err));
        }

        return next(action);
    };
}

export default ticketViewMiddleware;
